import type { Resource } from '../../';
export const product_group_allgender: Resource = {"default":"All Gender"};
